import {
  getCrqParametersFromFormDataAndUser,
  getCrqParametersFromFormDataAndUserVINE,
  getExistingCrqIdFromState,
  getFormDataFromState,
} from 'AppSrc/core/components/forms/form-types/create-crq/get-create-crq-parameters';
import moment from 'moment-timezone';
import { getCrqWIIParamsFromFormDataAndUser, getMobileVINEWIIParams } from 'AppSrc/core/components/forms/form-types/create-crq/get-work-info-item-parameters';
import { createUpdateCrq } from 'AppSrc/core/crq/crq-actions';
import { createWorkInfoItemsForCRQ } from 'AppSrc/core/work-info-items/work-info-item-actions';
import { CREATE_CRQ } from 'AppSrc/core/components/create-crq-screen/create-crq-screen-consts';
import { CRQ_STATUS_TRANSITIONS } from 'AppSrc/core/crq/crq-status-transitions';
import {
  FIXED,
  MOBILE,
} from 'AppSrc/core/components/forms/value-dependency-constants';
import { RAISING_CRQ } from 'AppSrc/core/components/forms/form-base-components/data-structure/constants';
import { getUnsavedApproverGroups, getUnsavedApproverGroupsOlo } from 'AppSrc/core/components/forms/form-types/create-crq/approvers-section/approvers-section-logic';
import { getUnsavedRelationships } from 'AppSrc/core/components/forms/form-types/create-crq/relationships/relationships-section-logic';
import { searchConfigItems } from 'AppSrc/core/relationships/relationships-queries';
import { setSponsorForCrq } from 'AppSrc/core/sponsor/sponsor-actions';
import { addApproverGroupsToCrq } from 'AppSrc/core/approvers/approver-groups-actions';
import { flAddApproverGroupsToCrq, individualAddApproverGroupsToCrq } from 'AppSrc/core/crq/crq-list-actions';
import { updateCrqRelationships, updateVINERelationship } from 'AppSrc/core/relationships/relationships-actions';
import {
  getModalDataForWorkInfoItems,
  getModalDataForRelationships,
} from 'AppSrc/core/crq/crq-form-utils';
import { getCrq } from 'AppSrc/core/crq/crq-queries';
import {
  getIsOlaCrq,
  getIsInternationalCrq,
  isCrqEmergency,
} from 'AppSrc/core/components/forms/form-types/create-crq/common-logic';
import {
  submitFormRequest,
  submitFormSuccess,
  submitFormError,
  switchLocalWIIsForServerWIIs,
  switchLocalRelationshipsForServerRelationships,
  setUnsavedRelationshipsMainForm,
} from './actions-main-form';

// import { submitEditFormRequest } from './actions-edit-form';


// thunk action to collect the create CRQ form data and submit to the endpoint
// passing in an existingCrqId will update the crq. If an existingCrqId is not
// provided, a new CRQ is created
// This action dispatches createUpdateCrq
const submitAndUpdateCreateCrqForm = (statusTransition = CRQ_STATUS_TRANSITIONS.raiseCrq) => (dispatch, getState) => {
  const user = getState().auth.user;
  const newStatus = statusTransition.targetStatus;
  const crqParams = getCrqParametersFromFormDataAndUser(getFormDataFromState(getState()), user, newStatus);
  const existingCrqId = getExistingCrqIdFromState(getState());
  // Need the network so we can return it on success
  const network = crqParams.network;

  dispatch(submitFormRequest(CREATE_CRQ));
  return dispatch(createUpdateCrq({
    crqData: crqParams,
    crqId: existingCrqId,
  }))
    .then((crqId) => {
      const formData = getFormDataFromState(getState());
      // const isOloCrq = getIsOlaCrq(formData);
      const changeDetails = 'CHANGE_DETAILS';
      const isOloByService = formData.dataByFormSectionId[changeDetails] ? formData.dataByFormSectionId[changeDetails].dataByFieldId.services.value === 'Network: Other Licensed Operator (OLO)' || formData.dataByFormSectionId[changeDetails].dataByFieldId.services.value === 'Network: International Other Licensed Operator (OLO)' : null;
      const isOloCrq = getIsOlaCrq(formData) || isOloByService;
      const isIcmCrqs = getIsInternationalCrq(formData);
      const newParams = getCrqParametersFromFormDataAndUser(getFormDataFromState(getState()), user, newStatus);
      const individualApprovers = getState().individualApproverList.ApproversList;


      let approverGroups = [];
      if (network === FIXED && (!isOloCrq || isIcmCrqs)) {
        approverGroups = getUnsavedApproverGroups(formData);
      }
      else if (isOloCrq && newParams.status === '4') {
        approverGroups = getUnsavedApproverGroupsOlo;
      }
      // if there is are no unsaved approver groups
      // move on to the next `then`
      if (!approverGroups || approverGroups.length === 0) {
        console.log('>>No group Selected Func');
        if (individualApprovers.length > 0) {
          dispatch(individualAddApproverGroupsToCrq(network, crqId, individualApprovers));
        }
        return crqId;
      }
      // return true;
      return dispatch(addApproverGroupsToCrq({
        formData,
        approverGroups,
        formFlow: RAISING_CRQ,
      })).then(() => {
        if (individualApprovers.length > 0) {
          dispatch(individualAddApproverGroupsToCrq(network, crqId, individualApprovers));
        }
        return crqId;
      }); // on success return the crq to the next then
    })
    .then((crqId) => {
      const formData = getFormDataFromState(getState());
      // const isOloCrq = getIsOlaCrq(formData);
      const changeDetails = 'CHANGE_DETAILS';
      const isOloByService = formData.dataByFormSectionId[changeDetails] ? formData.dataByFormSectionId[changeDetails].dataByFieldId.services.value === 'Network: Other Licensed Operator (OLO)' || formData.dataByFormSectionId[changeDetails].dataByFieldId.services.value === 'Network: International Other Licensed Operator (OLO)' : null;
      const isOloCrq = getIsOlaCrq(formData) || isOloByService;
      // dispatching individual add approver call in olo scenario.
      if (isOloCrq && crqParams.status === '4') {
        return dispatch(flAddApproverGroupsToCrq(network, crqId));
      }
      return crqId;
    })
    .then((response) => {
      const formDatas = getFormDataFromState(getState());
      // const isOloCrqs = getIsOlaCrq(formDatas);
      const changeDetails = 'CHANGE_DETAILS';
      const isOloByService = formDatas.dataByFormSectionId[changeDetails] ? formDatas.dataByFormSectionId[changeDetails].dataByFieldId.services.value === 'Network: Other Licensed Operator (OLO)' || formDatas.dataByFormSectionId[changeDetails].dataByFieldId.services.value === 'Network: International Other Licensed Operator (OLO)' : null;
      const isOloCrqs = getIsOlaCrq(formDatas) || isOloByService;
      const isEmergency = isCrqEmergency(formDatas);
      // will return crqid if its emergency crq
      if (isEmergency && isOloCrqs) {
        return formDatas.crqId;
      }
      // Normal olo cll and will skip this if is emergency crq
      if (response === 200 && isOloCrqs && !isEmergency) {
        const newParams = getCrqParametersFromFormDataAndUser(getFormDataFromState(getState()), user, newStatus);
        newParams.status = '5';
        return dispatch(createUpdateCrq({
          crqData: newParams,
          crqId: existingCrqId,
        }));
      }
      return response;
    })
    // Here is a change in order of API calls in order to prevent WII API calls when not required. Previously WII API was followed by sponsor API
    .then((crqId) => {
      const formData = getFormDataFromState(getState());
      const sponsor = formData.unsavedSponsorValue;
      // if there is no new sponsor value to save to the endpoint
      // move on to the next `then`
      if (!sponsor) {
        return crqId;
      }
      return dispatch(setSponsorForCrq({
        crqId,
        network,
        sponsor,
      })).then(() => crqId); // on success return the crq to the next then
    })
    .then(
      // get the work info items out of formData and user
      (crqId) => (
        // get the latest formData, as crqId has been updated in state
        getCrqWIIParamsFromFormDataAndUser({
          formData: getFormDataFromState(getState()),
          user,
          statusTransition,
        })
          .then(
            (workInfoItemParams) => {
              const formData = getFormDataFromState(getState());
              // const isOloCrq = getIsOlaCrq(formData);
              const changeDetails = 'CHANGE_DETAILS';
              const isOloByService = formData.dataByFormSectionId[changeDetails] ? formData.dataByFormSectionId[changeDetails].dataByFieldId.services.value === 'Network: Other Licensed Operator (OLO)' || formData.dataByFormSectionId[changeDetails].dataByFieldId.services.value === 'Network: International Other Licensed Operator (OLO)' : null;
              const isOloCrq = getIsOlaCrq(formData) || isOloByService;
              const isIcmCrqs = getIsInternationalCrq(formData);
              // Here is the logic to prevent WII API call if sponsor API fails i.e returning No CRQ
              if (network === 'mobile' && (crqId !== null)) {
                dispatch(createWorkInfoItemsForCRQ(crqId, workInfoItemParams))
                  .then(
                    ({ workItems }) => {
                      if (workItems) {
                        // create form modal data for the returned work items
                        // these have been populated with ids from the server
                        const modalDataForWorkInfoItems = getModalDataForWorkInfoItems(workItems, network);
                        dispatch(switchLocalWIIsForServerWIIs(CREATE_CRQ, modalDataForWorkInfoItems));
                      }
                      return crqId;
                    },
                  );
              }
              // WII Api call fot fixed, OLO and International. Previously WII API call was same for all networks
              if (((network === 'fixed') && (isOloCrq || isIcmCrqs)) || ((network === 'fixed') && (!isOloCrq && !isIcmCrqs))) {
                dispatch(createWorkInfoItemsForCRQ(crqId, workInfoItemParams))
                  .then(
                    ({ workItems }) => {
                      if (workItems) {
                        // create form modal data for the returned work items
                        // these have been populated with ids from the server
                        const modalDataForWorkInfoItems = getModalDataForWorkInfoItems(workItems, network);
                        dispatch(switchLocalWIIsForServerWIIs(CREATE_CRQ, modalDataForWorkInfoItems));
                      }
                      return crqId;
                    },
                  );
              }
              return crqId;
            },
          )
      ),
    )
    .then((crqId) => {
      const formData = getFormDataFromState(getState());
      const unsavedRelationships = network === MOBILE ? getUnsavedRelationships(formData) : [];
      if (!unsavedRelationships || unsavedRelationships.length === 0) {
        // if there are no values to save move on to next then
        return crqId;
      }
      return dispatch(updateCrqRelationships({
        crqId,
        unsavedRelationships,
        formFlow: RAISING_CRQ,
      })).then(() => {
        // clear any unsaved relationships
        dispatch(setUnsavedRelationshipsMainForm({
          formId: CREATE_CRQ,
          unsavedRelationships: [],
        }));
        // we need to call getCrq to get any relationship ids
        // and retrieve any generated relationships
        getCrq(network, crqId).then(({ crq }) => {
          const { relationships } = crq;
          if (relationships) {
            const modalDataForRelationships = getModalDataForRelationships(relationships, network);
            dispatch(switchLocalRelationshipsForServerRelationships(CREATE_CRQ, modalDataForRelationships));
          }
        });
        return crqId;
      }); // on success return the crq to the next then
    })
    // making a new api call here for add_approver_group to pass group id.
    .then(
      (crqId) => {
        const formData = getFormDataFromState(getState());
        const comms = network === 'mobile' ? formData.dataByFormSectionId.CHANGE_DETAILS.dataByFieldId.comms_required.value[0] : null;

        const isExpedited = formData.dataByFormSectionId.CHANGE_QUESTIONS.dataByFieldId.timing.value[0];
        console.log('isexpedited', formData, crqParams, isExpedited);
        let approverGroups = [];
        if ((crqParams.status === 'Scheduled For Review' && (formData.riskValue === 'Risk Level 3' || formData.riskValue === 'Risk Level 4') && comms === 'Yes') || (crqParams.status === 'Scheduled For Review' && isExpedited === 'Expedited')) {
          console.log('Mob comms check block');
          approverGroups = ['Mobile Communications Check']; // since we were getting undefined approver group here, hence hardcoded for passing group id when defined.
        }
        dispatch(addApproverGroupsToCrq({
          formData,
          approverGroups,
        }));
        dispatch(submitFormSuccess(CREATE_CRQ));
        return {
          crqId,
          network,
        };
      },
    )
    .catch((error) => {
      dispatch(submitFormError(CREATE_CRQ, error));
      return Promise.reject(error);
    });
};

// To create duplicate crq using existing crq
const submitAndUpdateCloneCreateCrqForm = (statusTransition = CRQ_STATUS_TRANSITIONS.raiseCrq, cloneCrqId) => (dispatch, getState) => {
  const user = getState().auth.user;
  const newStatus = statusTransition.targetStatus;
  const formData = getState().editForm.formDataById[cloneCrqId];
  const crqParams = getCrqParametersFromFormDataAndUser(formData, user, newStatus);
  crqParams.status_reason = null;
  const network = crqParams.network;
  // Need the network so we can return it on success
  // const network = crqParams.network;

  dispatch(submitFormRequest(CREATE_CRQ));
  return dispatch(createUpdateCrq({
    crqData: crqParams,
    crqId: null,
  }))
    .then((crqId) => {
      // if there is no new sponsor value to save to the endpoint
      // move on to the next `then`
      const changeDetails = 'CHANGE_DETAILS';
      if (network === 'mobile') {
        const sponsor = formData.dataByFormSectionId[changeDetails] ? formData.dataByFormSectionId[changeDetails].dataByFieldId['assign-sponsor'].value : null;
        if (!sponsor || network !== 'mobile') {
          return crqId;
        }
        return dispatch(setSponsorForCrq({
          crqId,
          network,
          sponsor,
        })).then(() => crqId); // on success return the crq to the next then
      }
      return crqId;
    })
    .catch((error) => {
      dispatch(submitFormError(CREATE_CRQ, error));
      return Promise.reject(error);
    });
};
// For Create Mobile refrence ticket from fixed circuit check - VINE
// This action dispatches createUpdateCrq
const submitAndUpdateCreateCrqFormVINE = (statusTransition = CRQ_STATUS_TRANSITIONS.raiseCrq, existingCrqId) => (dispatch, getState) => {
  const user = getState().auth.user;
  const newStatus = statusTransition.targetStatus;
  const existingCrqIdNull = getExistingCrqIdFromState(getState());
  const formDataMobile = getState().editForm.formDataById[existingCrqId];
  const getRelCoordinatorId = getState().remedyReferenceCrq.selectedRelCordinator;
  const crqParams = getCrqParametersFromFormDataAndUserVINE(formDataMobile, user, newStatus, existingCrqId, getRelCoordinatorId);
  // moment.tz(value, timezone) moment.tz(selectedDateToUse, timezone)
  crqParams.scheduled_start_date = moment(crqParams.scheduled_start_date).tz('Europe/London');
  crqParams.scheduled_end_date = moment(crqParams.scheduled_end_date).tz('Europe/London');
  // Need the network so we can return it on success
  crqParams.network = 'mobile';
  dispatch(submitFormRequest(CREATE_CRQ));
  return dispatch(createUpdateCrq({
    crqData: crqParams,
    crqId: existingCrqIdNull,
  }))
    .then(
      // get the work info items out of formData and user
      (crqId) => (
        // get the VINE WII data, as crqId has been updated in state
        getMobileVINEWIIParams({
          crqId,
          formData: formDataMobile,
          network: 'mobile',
          user,
        })
          .then(
            (workInfoItemParams) => {
              const network = 'mobile';
              // Here is the logic to prevent WII API call if sponsor API fails i.e returning No CRQ
              if ((crqId != null)) {
                dispatch(createWorkInfoItemsForCRQ(crqId, workInfoItemParams))
                  .then(
                    ({ workItems }) => {
                      if (workItems) {
                        // create form modal data for the returned work items
                        // these have been populated with ids from the server
                        const modalDataForWorkInfoItems = getModalDataForWorkInfoItems(workItems, network);
                        dispatch(switchLocalWIIsForServerWIIs(CREATE_CRQ, modalDataForWorkInfoItems));
                      }
                      return crqId;
                    },
                  );
              }
              return crqId;
            },
          )
      ),
    )
    .then((crqId) => {
      // Add CI relationship o VINE
      const searchQuery = 'Dummy CI (For Change Management)';
      let relationship = '';
      searchConfigItems(MOBILE, searchQuery)
        .then((response) => {
          relationship = response;
          const unsavedRelationships = updateVINERelationship(
            crqId,
            relationship[0],
          );
          return dispatch(updateCrqRelationships({
            crqId,
            unsavedRelationships,
            formFlow: RAISING_CRQ,
          })).then(() => crqId);
        });
      return crqId;
    })
    .catch((error) => {
      dispatch(submitFormError(CREATE_CRQ, error));
      return Promise.reject(error);
    });
};

// Func for cancel crq with statustransitin cancel no longer required
const submitAndCancelCreateCrqForm = (statusTransition, selectedReason) => (dispatch, getState) => {
  const user = getState().auth.user;
  const newStatus = statusTransition.targetStatus;
  const crqParams = getCrqParametersFromFormDataAndUser(getFormDataFromState(getState()), user, newStatus, selectedReason);
  const existingCrqId = getExistingCrqIdFromState(getState());
  // Need the network so we can return it on success
  // const network = crqParams.network;
  // dispatch(submitFormRequest(CREATE_CRQ));
  return dispatch(createUpdateCrq({
    crqData: crqParams,
    crqId: existingCrqId,
  }))
    .then(
      (crqId) => {
        console.log('###Success....', crqId);
        return {
          crqId,
        };
      },
    ).then((crqId) => crqId)
    .catch((error) => {
      dispatch(submitFormError(CREATE_CRQ, error));
      return Promise.reject(error);
    });
};

export {
  submitAndUpdateCreateCrqForm,
  submitAndUpdateCreateCrqFormVINE,
  submitAndCancelCreateCrqForm,
  submitAndUpdateCloneCreateCrqForm,
};
